import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@material-ui/core';
import { Grid } from '@mui/material';
import { SGSForm, SGSFormLayout, SGSRadioCtr } from 'components';
import { useArretTravailFormContext } from 'features/arretTravail/contexts/ArretTravailFormProvider';
import useValidationEffects from 'features/arretTravail/hooks/useValidationEffects';
import { optionTypeDeclaration } from 'features/arretTravail/models/typeChoix/index';
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import styles from '../../../css/ArretTravail.module.scss';

type Props = {
    store: any;
    onSubmit: SubmitHandler<DeclarationTypeSchema>;
    actions?: JSX.Element;
};

type DeclarationTypeSchema = {
    typeDeclarationCod: string;
};

const FormDeclarationType: React.FC<Props> = ({ onSubmit, store, actions }) => {
    const { t } = useTranslation();
    const { activeStep, setStepFailed } = useArretTravailFormContext();

    const validationSchema: Yup.SchemaOf<DeclarationTypeSchema> = Yup.object().shape({
        typeDeclarationCod: Yup.string().required(t('yup.validators.required')),
    });

    const methods = useForm<DeclarationTypeSchema>({
        resolver: yupResolver(validationSchema),
        defaultValues: store,
    });

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = methods;

    useValidationEffects({ errors, activeStep, setStepFailed, control });

    return (
        <FormProvider {...methods}>
            <SGSFormLayout onSubmit={handleSubmit(onSubmit)} actions={actions}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={6}>
                        <Box className={styles.title}>Type de déclaration :</Box>
                        <SGSForm.Row>
                            <SGSForm.Col>
                                <SGSRadioCtr row options={optionTypeDeclaration} name="typeDeclarationCod" className="mb-n3" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                    </Grid>
                </Grid>
            </SGSFormLayout>
        </FormProvider>
    );
};

export default FormDeclarationType;
